import React, { useEffect, useState } from "react";
import ICONS from "../Constants/Icons.tsx";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";
import { LBMCSidebar } from "@lbmc-digital/lbmc-ui-kit";
import { useTheme } from '../ThemeContext/ThemeContext.tsx';
import SessionService from "../Services/SessionService";
import { useUserContext } from "../Context/UserContext.tsx";


export default function Sidebar() {

  const { role, isAdmin, isGrowthTeam, isGrowthLeader } = useUserContext();
  const Icon = ICONS();
  const { instance } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();
  const { isDarkMode, toggleDarkMode } = useTheme();

  const isDarkModeActivated = localStorage.getItem("IsDarkModeActivated");
  const [activeDarkMode, setActiveDarkMode] = useState(
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );


  const [isStaredState, setIsStaredState] = React.useState<boolean>(    location.pathname === "/"
  );
  // eslint-disable-next-line
  const [isActiveRoute, setIsActiveRoute] = React.useState<boolean>(location.pathname === "/engagements");
  const onDarkmodeClick = () => {
    toggleDarkMode();
  };

  const onStarClick = () => {
    const isEditorDirty = localStorage.getItem("isEditorDirty") === 'true';
    if (isEditorDirty) {
      const confirmLeave = window.confirm("Changes you made may not be saved.");
      if (!confirmLeave) {
        return;
      }
      localStorage.removeItem("isEditorDirty");
    }
    
    setIsStaredState(true);
    setIsActiveRoute(false); 
    SessionService.setNavigateTo('LeaderLandingPage')
    navigate("/");
  };

  const onLogoutClick = () => {
    SessionService.clearSession();
    instance.logoutRedirect();
  };

  const onHelpClick = () => {
    window.open(`${process.env.REACT_APP_THINK_HELP_URL}`, "_blank");
  };

  const extraButtons = (
    <div className="flex position-relative sidebar-container">
        <div className="sidebar mt-6 relative gap-2">
        <Tooltip target=".sidebar-tooltip" />

        {
          role == "Leader" || role == "CoLeader" || role == "Leader & CoLeader" || isGrowthLeader ? (
            <>
              <Button
                icon={<img src={Icon.HomeIcon} alt="HomeIcon" />}
                className="p-button-text p-button-info sidebar-tooltip"
                aria-label="Dashboard"
                data-pr-tooltip="Dashboard"
                data-pr-position="right"
                onClick={(e) => {
                  e.preventDefault();
                  onStarClick();
                }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0.20rem",
                }}
              />
              <Button
                icon={<img src={Icon.AverageNew} alt="AverageIcon" />}
                className="mt-1 p-button-text p-button-info sidebar-tooltip"
                aria-label="Averages"
                data-pr-tooltip="Averages"
                data-pr-position="right"
                onClick={(e) => {
                  e.preventDefault();
                  SessionService.setNavigateTo('LeaderLandingPage')
                  navigate("/averages");
                }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0.20rem",
                }}
              />
              
            </>
          ) : null
        }         
{
  isAdmin ? (
    <Button
                icon={<img src={Icon.SlidersIcon} alt="SlidersIcon" />}
                className="mt-1 p-button-text p-button-info sidebar-tooltip"
                aria-label="Admin Panel"
                data-pr-tooltip="Admin Panel"
                data-pr-position="right"
                onClick={(e) => {
                  e.preventDefault();
                  SessionService.setNavigateTo('AdminPanel')
                  navigate("/apex-admin");
                }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0.20rem",
                }}
              />
  ) : null
}
        <div className="absolute bottom-0 flex-column flex mb-3 gap-2">
          <Button
            icon={<img src={Icon.DarkModeMoon} alt="DarkModeMoon" />}
            text
            severity="info"
            aria-label={isDarkMode ? "Light mode" : "Dark mode"}
            onClick={onDarkmodeClick}
            className="sidebar-tooltip cursor-pointer"
            data-pr-tooltip={isDarkMode ? "Light mode" : "Dark mode"}
            data-pr-position="right"
          />
          <Button
            icon={<img src={Icon.HelpIcon} alt="HelpIcon" />}
            text
            severity="info"
            aria-label="Help"
            onClick={onHelpClick}
            className="sidebar-tooltip cursor-pointer"
            data-pr-tooltip="Help"
            data-pr-position="right"
          />
          <Button
            icon={<img src={Icon.LogoutIcon} alt="LogoutIcon" />}
            text
            severity="info"
            aria-label="Logout"
            onClick={onLogoutClick}
            className="sidebar-tooltip cursor-pointer"
            data-pr-tooltip="Logout"
            data-pr-position="right"
          />
        </div>
        </div>
    </div>
  );

  return (
    <LBMCSidebar
      extraButtons={extraButtons}
      extraTooltips={<Tooltip target=".sidebar-tooltip" />}
      location={location}
      navigate={navigate}
      className="sidebar-apx"
    />
  );
}
